import { ref } from 'vue'

export const maintenanceMode = ref(false)
export const maintenanceMessage = ref('系统正在维护中，请稍后再试')

export function setMaintenanceMode(active: boolean, message?: string) {
  maintenanceMode.value = active
  if (message) {
    maintenanceMessage.value = message
  }
}
